// ═══════════════════════════════════════════════════════════
//  WORKSPACE v4 — PROTOTAIP DESIGN (/workspace-v4) — data contoh + fungsi TULEN
//
//  ⛔ PROTOTAIP UI/UX SAHAJA (arahan user 15 Okt 2026: "ini kan prototaip je. buang apa
//     yg wired. aku nk buat design ui ux je"). Tiada callable, tiada Firestore, tiada
//     storan. Semua isi di bawah = CONTOH untuk melihat rupa + aliran.
//     Sambung ke server HANYA bila user minta dengan jelas.
//
//  Susunan (keputusan user 15 Okt 2026, lakaran widget):
//    Add product → Select module (TAG perkataan) → Video style → Scene → Model → Avatar → Generate
//    • tag belum diklik → SEMUA style; klik tag → hanya style bertag itu; satu tag sahaja
//    • style tanpa muka (POV) → langkah Avatar disorok
//    • scene 1–5 pilih sendiri · model: Veo 3.1 Lite LP + Omni Flash · module semua terbuka
//
//  Uji: `node --test src/utils/generateV2.test.js`
// ═══════════════════════════════════════════════════════════

export const TEMPOH_BABAK = 8;      // saat setiap scene (keputusan user 9 Okt 2026)
export const MAKS_BABAK = 5;

// ── Data contoh ─────────────────────────────────────────────────────────────
// 18 Okt 2026 (arahan user): tag Kitchen DIBUANG → 6 module Workspace sebenar. Style contoh
// "diagih" ke module = CONTOH RUPA sahaja, bukan pemetaan sebenar (jawapan user).
// 18 Okt: tag "Formula" DIBUANG; tab "All" dinamakan "All Formula" = lalai (arahan user).
export const TAG_CONTOH = [
    { id: 'ai8saat', nama: 'AI8SAAT' },
    { id: 'ai16saat', nama: 'AI16SAAT' },
    { id: 'homeniche', nama: 'HOME NICHE' },
    { id: 'goyang', nama: 'GOYANG' },
    { id: 'smart', nama: 'SMART' },
    { id: 'flownity', nama: 'FLOWNITY' },
];

/* `ikon` = kunci ikon poster (GenerateV2Poster); `rentak` = langkah cerita pada poster rekaan.
   `guna` = BILANGAN VIDEO yang dijana dengan style ini (keputusan user 15 Okt 2026, ikut cadangan
   Claude: kira "digunakan", BUKAN butang save seperti BatchBot). Nombor di sini = CONTOH. Bila
   disambung kelak, nombor datang daripada jumlah sebenar. `baru` = style baharu → label "New",
   bukan "0". */
export const STYLE_CONTOH = [
    { id: 'unboxing', matlamat: 'sell', format: 'video', nama: 'Unboxing', kecil: 'First impression', tags: ['ai16saat', 'smart'], tanpaMuka: false, ikon: 'product-only', guna: 310, rentak: ['Hook', 'Open the box', 'Contents', 'Close look', 'Verdict'] },
    { id: 'demo', matlamat: 'sell', format: 'video', nama: 'Demo', kecil: 'Step by step', tags: ['ai16saat'], tanpaMuka: false, ikon: 'multi-angle-demo', guna: 860, rentak: ['Hook', 'Setup', 'Main use', 'Detail', 'Result'] },
    { id: 'model', matlamat: 'sell', format: 'video', nama: 'Model holding product', kecil: 'Presenter', tags: ['goyang'], tanpaMuka: false, ikon: 'model-showcase', guna: 0, baru: true, rentak: ['Hook', 'Introduce', 'Show feature', 'Benefit', 'CTA'] },
    { id: 'pov', matlamat: 'sell', format: 'video', nama: 'POV', kecil: 'Hands only, no face', tags: ['homeniche'], tanpaMuka: true, ikon: 'pov-hands', guna: 1240, rentak: ['Hook', 'Before', 'Process', 'Reveal', 'Payoff'] },
    // AI8SAAT = 3 kad ini SAHAJA (arahan user 18 Okt). Nombor `guna` contoh disusun menurun supaya
    // turutan kad 1 → 2 → 3 kekal walaupun galeri disusun "most used first".
    { id: 'ai8-hold', matlamat: 'sell', format: 'video', pil: 'HOLD', poster: '/prototype/ws4/ai8-hold.png', video: 'https://pub-3ea9faec4f034af7b4ca04c37398b059.r2.dev/prototype/ws4/ai8-hold.mp4', nama: 'Model Hold Product', kecil: 'Model presents the product', tags: ['ai8saat'], tanpaMuka: false, ikon: 'model-showcase', guna: 520, rentak: ['Hook', 'Hold up', 'Show front', 'Point + smile', 'CTA'] },
    { id: 'ai8-demo', matlamat: 'sell', format: 'video', pil: 'DEMO', poster: '/prototype/ws4/ai8-demo.svg', video: 'https://pub-3ea9faec4f034af7b4ca04c37398b059.r2.dev/prototype/ws4/ai8-demo.mp4', nama: 'Model + Demo Product', kecil: 'Model uses the product', tags: ['ai8saat'], tanpaMuka: false, ikon: 'multi-angle-demo', guna: 410, rentak: ['Hook', 'Setup', 'Demo', 'Result', 'CTA'] },
    { id: 'ai8-zoom', matlamat: 'sell', format: 'video', pil: 'ZOOM', poster: '/prototype/ws4/ai8-zoom.svg', video: 'https://pub-3ea9faec4f034af7b4ca04c37398b059.r2.dev/prototype/ws4/ai8-zoom.mp4', nama: 'Model + Zoom Product', kecil: 'Model + close-up detail', tags: ['ai8saat'], tanpaMuka: false, ikon: 'macro-detail', guna: 280, rentak: ['Hook', 'Hold', 'Zoom in', 'Detail', 'CTA'] },
    { id: 'talking-head', matlamat: 'sell', format: 'video', nama: 'Talking head', kecil: 'Review to camera', tags: ['smart', 'flownity'], tanpaMuka: false, ikon: 'ugc-talking-head', guna: 640, rentak: ['Hook', 'Problem', 'Product', 'Proof', 'CTA'] },
    // 22 Okt (arahan user): kad Image / Text di bawah = CONTOH RUPA sahaja (tiada module sebenar lagi).
    { id: 'carousel', matlamat: 'sell', format: 'image', nama: 'Carousel', kecil: '5 product slides', tags: [], tanpaMuka: true, ikon: 'product-only', guna: 420, rentak: ['Cover', 'Feature', 'Detail', 'Price', 'CTA'] },
    { id: 'review-post', matlamat: 'sell', format: 'text', nama: 'Review post', kecil: 'Caption + CTA', tags: [], tanpaMuka: true, ikon: 'ugc-talking-head', guna: 600, rentak: ['Hook', 'Problem', 'Review', 'Proof', 'CTA'] },
    { id: 'ai-photo', matlamat: 'grow', format: 'image', nama: 'AI photo', kecil: 'Niche photos', tags: [], tanpaMuka: true, ikon: 'macro-detail', guna: 910, rentak: ['Scene', 'Mood', 'Detail', 'Angle', 'Close'] },
    { id: 'daily-text', matlamat: 'grow', format: 'text', nama: 'Daily text', kecil: 'Tips post', tags: [], tanpaMuka: true, ikon: 'asmr-visual', guna: 540, rentak: ['Hook', 'Tip 1', 'Tip 2', 'Tip 3', 'Question'] },
    { id: 'aesthetic-loop', matlamat: 'grow', format: 'video', nama: 'Aesthetic loop', kecil: 'Faceless', tags: [], tanpaMuka: true, ikon: 'asmr-visual', guna: 380, rentak: ['Mood', 'Loop', 'Detail', 'Texture', 'Loop back'] },
    { id: 'story-video', matlamat: 'earn', format: 'video', nama: 'Story to video', kecil: 'Narrated scenes', tags: [], tanpaMuka: false, ikon: 'cinematic-showcase', guna: 700, rentak: ['Hook', 'Setup', 'Twist', 'Climax', 'Ending'] },
    { id: 'story-images', matlamat: 'earn', format: 'image', nama: 'Story to images', kecil: 'Image set', tags: [], tanpaMuka: false, ikon: 'cinematic-showcase', guna: 480, rentak: ['Opening', 'Setup', 'Twist', 'Climax', 'Ending'] },
    { id: 'story-script', matlamat: 'earn', format: 'text', nama: 'Story script', kecil: 'Long-form text', tags: [], tanpaMuka: true, ikon: 'product-only', guna: 0, baru: true, rentak: ['Hook', 'Setup', 'Story', 'Lesson', 'Ending'] },
    { id: 'lifestyle', matlamat: 'grow', format: 'video', nama: 'Daily routine', kecil: 'Lifestyle', tags: ['homeniche', 'flownity'], tanpaMuka: false, ikon: 'lifestyle-ugc', guna: 95, rentak: ['Moment', 'Routine', 'Product', 'Feeling', 'CTA'] },
];
export const BIL_POPULAR = 3;

/* Matlamat pelanggan = TAB utama galeri (arahan user 22 Okt, menggantikan tab module):
   Sell = affiliate TikTok + Shopee · Grow = ternak / warm up akaun TikTok / FB page · Earn = monetize
   YouTube + FB Pro. Format (Video / Image / Text) = TAG pada kad + Filter, BUKAN kumpulan berasingan. */
export const MATLAMAT_CONTOH = [
    { id: 'sell', nama: 'Sell', nota: 'TikTok + Shopee affiliate' },
    { id: 'grow', nama: 'Grow', nota: 'Warm up TikTok / FB page' },
    { id: 'earn', nama: 'Earn', nota: 'Monetize YouTube + FB Pro' },
];
export const FORMAT_CONTOH = [
    { id: 'video', nama: 'Video' },
    { id: 'image', nama: 'Image' },
    { id: 'text', nama: 'Text' },
];
export const SUSUN_STYLE = [
    { id: 'guna', nama: 'Most used' },
    { id: 'baru', nama: 'Newest' },
    { id: 'az', nama: 'A–Z' },
];

/* Kad "Blank Card" (arahan user 20 Okt): kad TETAP pertama, HANYA dalam tab All Formula. Ia cipta
   kad Workspace kosong TANPA AI pipeline (pelanggan isi sendiri). Tiada nombor guna, tiada tag,
   tidak ikut susunan popular. PROTOTAIP: tidak membuat apa-apa. */
export const KAD_KOSONG = { id: 'blank', nama: 'Blank Card', kecil: 'No AI — fill it in yourself', kosong: true, tags: [], rentak: [] };   // label "Popular" pada 3 style paling banyak digunakan (SEMUA style, bukan ikut tag)

export const PRODUK_CONTOH = [
    { id: 'p1', name: 'Periuk Non-Stick 24cm' },
    { id: 'p2', name: 'Pisau Set 6 pcs' },
    { id: 'p3', name: 'Bekas Makanan Kaca 3 Petak' },
    { id: 'p4', name: 'Rak Rempah Berputar' },
];

export const MODEL_CONTOH = [
    // `pendek` + `nota` = dua baris dalam kotak model (C4, arahan user 23 Okt).
    { id: 'veo', nama: 'Veo 3.1 Lite LP', pendek: 'Veo 3.1', nota: 'Lite LP' },
    { id: 'omni', nama: 'Omni Flash', pendek: 'Omni', nota: 'Flash' },
];

/* Sama bentuk pilihan avatar Workspace sebenar: No avatar · Default (M)/(F) · avatar simpanan.
   ⚠️ PROTOTAIP: huruf pertama menggantikan gambar avatar (corak /workspace-v3.9). */
export const AVATAR_CONTOH = [
    { id: '', nama: 'No avatar', kosong: true },
    { id: '__male__', nama: 'Default (M)', inisial: 'L' },
    { id: '__female__', nama: 'Default (F)', inisial: 'P' },
    { id: 'a1', nama: 'Aisyah', inisial: 'A', gender: 'Female', simpanan: true },
    { id: 'a2', nama: 'Faiz', inisial: 'F', gender: 'Male', simpanan: true },
];
export const SLOT_AVATAR = 5;

/* Kepala Workspace (arahan user 18 Okt: "letak sekali ni dlm prototaip, jgn ada wired"):
   pemilih group + tab Generate / My Agent / Flow / Schedule — nombor = CONTOH. */
export const GROUP_CONTOH = [
    { id: 'main', nama: 'Main Group', kira: 43 },
    { id: 'g-promo', nama: 'Promo 11.11', kira: 12 },
];
/* 3 kad contoh setiap tab My Agent + Flow (arahan user 18 Okt). Bentuk SAMA dengan `CONTOH`
   WorkspaceV39View.jsx kerana baris kad = `ProductRow` v3.9 yang dipakai semula. `masa` = turutan contoh. */
export const KAD_CONTOH = {
    agent: [
        { id: 'a1', masa: 3, sku: '1729613840653126606', name: 'Mr Power Spray Pembasmi Serangga – Untuk Semua Jenis Serangga', host: 'shop.tiktok.com', formula: 'SMART', avatar: false, gender: null, thumb: 'linear-gradient(135deg,#86efac,#15803d)', videos: [1, 0, 0] },
        { id: 'a2', masa: 2, sku: '1733167143013746644', name: 'Tadabbur 30; Sinopsis Tadabbur 30 Juz + 114 Surah + Tadabbur 4 Musim Emosi dengan 99 Asmaul Husna', host: 'shop.tiktok.com', formula: 'SMART', avatar: false, gender: null, thumb: 'linear-gradient(135deg,#a5b4fc,#4338ca)', videos: [0, 0, 0] },
        { id: 'a3', masa: 1, sku: '1729479113004472281', name: 'Minyak Wangi Attar Musk Al-Haramain 12ml', host: 'shop.tiktok.com', formula: 'SMART', avatar: true, gender: 'Men', thumb: 'linear-gradient(135deg,#fcd34d,#b45309)', videos: [1, 1, 0] },
    ],
    flow: [
        { id: 'f1', masa: 3, sku: '1729535475451004628', name: 'PERFUME PARADISE PEN FOR WOMEN — Packaging Baru (10 ml)', host: 'shop.tiktok.com', formula: 'AI8SAAT', avatar: true, gender: 'Women', thumb: 'linear-gradient(135deg,#f9a8d4,#be185d)', videos: [1, 0, 0] },
        { id: 'f2', masa: 2, sku: '1729480091223841902', name: 'Set Tudung Bawal Premium Cotton Voal', host: 'shop.tiktok.com', formula: 'GOYANG', avatar: false, gender: null, thumb: 'linear-gradient(135deg,#fca5a5,#b91c1c)', videos: [1, 1, 0] },
        { id: 'f3', masa: 1, sku: '1729478550118822943', name: 'Umpan Semut Ant Bait Roach Killer Gel 10g', host: 'shop.tiktok.com', formula: 'HOME NICHE', avatar: false, gender: null, thumb: 'linear-gradient(135deg,#93c5fd,#1e3a8a)', videos: [0, 0, 0] },
    ],
};

/* Susunan kad — jenis SAMA seperti Workspace v3.9 (Number · Time · Module). Bentuk `pilihan` SusunMenuV39. */
export const SUSUN_CONTOH = [
    { id: 'nombor', label: 'Number', lalai: 'asc', tip: { asc: 'Number, low to high', desc: 'Number, high to low' } },
    { id: 'masa', label: 'Time', lalai: 'desc', tip: { asc: 'Oldest first', desc: 'Newest first' } },
    { id: 'module', label: 'Module', lalai: 'asc', tip: { asc: 'Module, A to Z', desc: 'Module, Z to A' } },
];

export function susunKad(kad, jenis, arah) {
    const banding = {
        nombor: (a, b) => String(a.sku).localeCompare(String(b.sku), undefined, { numeric: true }),
        masa: (a, b) => (a.masa || 0) - (b.masa || 0),
        module: (a, b) => String(a.formula || '').localeCompare(String(b.formula || '')),
    }[jenis] || (() => 0);
    const darab = arah === 'asc' ? 1 : -1;
    return [...(Array.isArray(kad) ? kad : [])].sort((a, b) => banding(a, b) * darab);
}

export const TAB_CONTOH = [
    { value: 'generate', label: 'Generate', kira: null },
    { value: 'agent', label: 'My Agent', kira: KAD_CONTOH.agent.length },
    { value: 'flow', label: 'Flow', kira: KAD_CONTOH.flow.length },
    { value: 'schedule', label: 'Schedule', kira: 10 },
];   // "New avatar 2/5" — sama seperti Workspace sebenar

// ── Fungsi tulen ────────────────────────────────────────────────────────────

/** "0:24" untuk 3 scene × 8s — bentuk sama dengan lencana tempoh kad formula lama. */
export function labelDurasi(bil, tempoh = TEMPOH_BABAK) {
    const s = Math.max(0, Math.round(Number(bil) * Number(tempoh)) || 0);
    return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

/** Rentak "Hook: the problem happening right now" → "Hook" (label pendek untuk poster rekaan). */
export function labelRentak(rentak, maks = 5) {
    return (Array.isArray(rentak) ? rentak : []).slice(0, maks).map((r) => {
        const s = String(r || '').trim();
        const i = s.indexOf(':');
        const kepala = i > 0 && i <= 22 ? s.slice(0, i) : s.split(/\s+/).slice(0, 2).join(' ');
        return kepala.length > 22 ? kepala.slice(0, 21) + '…' : kepala;
    }).filter(Boolean);
}

/** Tiada tag → semua style; ada tag → HANYA style yang bertag itu (style tanpa tag tidak ikut). */
export function tapisStyle(style, tagId) {
    const semua = Array.isArray(style) ? style : [];
    if (!tagId) return semua;
    return semua.filter((s) => Array.isArray(s.tags) && s.tags.includes(tagId));
}

/** Matlamat '' = semua; format '' = semua format. */
export function tapisMatlamat(style, matlamatId, formatId) {
    return (Array.isArray(style) ? style : [])
        .filter((s) => (!matlamatId || s.matlamat === matlamatId) && (!formatId || s.format === formatId));
}

/** Susunan galeri: 'guna' = paling banyak digunakan · 'baru' = style baharu dahulu, kemudian terkini ditambah · 'az' = ikut nama. */
export function susunStyle(style, jenis) {
    const senarai = Array.isArray(style) ? style : [];
    if (jenis === 'az') return [...senarai].sort((a, b) => String(a.nama).localeCompare(String(b.nama)));
    if (jenis === 'baru') {
        return senarai.map((s, i) => ({ s, i }))
            .sort((a, b) => (Number(!!b.s.baru) - Number(!!a.s.baru)) || (b.i - a.i))
            .map((x) => x.s);
    }
    return susunPopular(senarai);
}

/** 95 → "95" · 1240 → "1.2k" · 18400 → "18k" (lencana kad). */
export function formatGuna(n) {
    const x = Math.max(0, Math.floor(Number(n) || 0));
    if (x < 1000) return String(x);
    if (x < 10000) return (x / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
    return Math.round(x / 1000) + 'k';
}

/** Paling banyak digunakan dahulu; style baharu di hujung (turutan asal dikekalkan bila sama). */
export function susunPopular(style) {
    return (Array.isArray(style) ? style : [])
        .map((s, i) => ({ s, i }))
        .sort((a, b) => (Number(!!a.s.baru) - Number(!!b.s.baru)) || ((Number(b.s.guna) || 0) - (Number(a.s.guna) || 0)) || (a.i - b.i))
        .map((x) => x.s);
}

/** Id style berlabel "Popular": `bil` teratas daripada SEMUA style (bukan style baharu, guna > 0). */
export function idPopular(style, bil = BIL_POPULAR) {
    return new Set(susunPopular(style).filter((s) => !s.baru && Number(s.guna) > 0).slice(0, bil).map((s) => s.id));
}

/**
 * Peta scene untuk pratonton panel (idea A, dipilih user 18 Okt): agih rentak style kepada
 * `bil` scene. Rentak > scene → rentak berjiran digabung ("Hook + Before"); scene > rentak →
 * rentak terakhir disambung ("Payoff (cont.)"). Rentak pertama sentiasa scene 1, terakhir scene akhir.
 */
export function petaScene(rentak, bil) {
    const r = (Array.isArray(rentak) ? rentak : []).filter(Boolean);
    const n = Math.max(1, Math.floor(Number(bil) || 1));
    if (!r.length) return Array.from({ length: n }, (_, i) => ({ no: i + 1, teks: '' }));
    if (n <= r.length) {
        const asas = Math.floor(r.length / n);
        const baki = r.length % n;
        const keluar = [];
        let k = 0;
        for (let i = 0; i < n; i++) {
            const saiz = asas + (i >= n - baki ? 1 : 0);
            keluar.push({ no: i + 1, teks: r.slice(k, k + saiz).join(' + ') });
            k += saiz;
        }
        return keluar;
    }
    return Array.from({ length: n }, (_, i) => {
        const j = Math.floor((i * r.length) / n);
        const ulang = i > 0 && Math.floor(((i - 1) * r.length) / n) === j;
        return { no: i + 1, teks: r[j] + (ulang ? ' (cont.)' : '') };
    });
}

/** Sebab butang Generate dimatikan — null bila semuanya sedia. Ayat English (UI admin).
 *  `kosong` = Blank Card dipilih → produk TIDAK wajib (keputusan user 1 Nov: kad kosong boleh
 *  dicipta tanpa produk; produk hanya opsyen). Style tetap wajib (styleId = 'blank' bila dipilih). */
export function sebabTakBolehJana({ produk, styleId, kosong }) {
    if (!kosong && !produk?.length) return 'Add a product first';
    if (!styleId) return 'Pick a video style first';
    return null;
}
